import Typography from '@mui/material/Typography';
import { DatePickerInput } from 'customer_portal-ui-shared';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { useAppSelector } from '../../hooks';

interface DateRangeProps {
    defaultBefore: Date | null; // Change type to Date or null
    defaultAfter: Date | null; // Change type to Date or null
    onChangeBefore?: (value: Date | null) => void; // Change type to Date or null
    onChangeAfter?: (value: Date | null) => void; // Change type to Date or null
}

const DateRanges = ({ defaultBefore, defaultAfter, onChangeBefore, onChangeAfter }: DateRangeProps) => {
    const [BeforeDate, setBeforeDate] = useState<Date | null>(defaultBefore); // Set initial state to DefaultBefore
    const [AfterDate, setAfterDate] = useState<Date | null>(defaultAfter); // Set initial state to DefaultAfter

    useEffect(() => {
        if (onChangeBefore) {
            onChangeBefore(BeforeDate);
        }
    }, [BeforeDate]);

    useEffect(() => {
        if (onChangeAfter) {
            onChangeAfter(AfterDate);
        }
    }, [AfterDate]);

    const handleKeyDownBeforeDate = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Delete' || event.key === 'Backspace') {
            setBeforeDate(null);
        }
    };

    const handleKeyDownAfterDate = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Delete' || event.key === 'Backspace') {
            setAfterDate(null);
        }
    };

    return (
        <div>
            <DatePickerInput onChange={setAfterDate} value={defaultAfter} label="On or After Date" withBorder onKeyDown={handleKeyDownAfterDate} />
            <Typography
                variant="overline"
                component="div"
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    margin: '0 12px',
                    fontSize: 12,
                    mt: '5px'
                }}
            >
                {'To'}
            </Typography>
            <DatePickerInput onChange={setBeforeDate} value={defaultBefore} label="On or Before Date" withBorder onKeyDown={handleKeyDownBeforeDate} />
        </div>
    );
};

export default DateRanges;
